export const DEBOUNCED_HANDLE_CHANGE_WAIT = 500;
